export default {
  name: { id: 'name' },
  seip: { id: 'seip' },
  siteType: { id: 'site_type' },
  active: { id: 'active' },
  visibleInUi: { id: 'visible_in_ui' },
  dateUpdated: { id: 'date_updated' },
  siteList: { id: 'site_list' },
  createSite: { id: 'create_site' },
  editSite: { id: 'edit_site' },
  deleteSite: { id: 'delete_site' },
  deleteSiteMessage: { id: 'delete_site_message' },
}
